import { generateId } from '@freelancer/datastore/testing/helpers';
import type { FlareAdminLog } from './flare-admin-logs.model';

export interface GenerateFlareAdminLog {
  readonly id?: number;
  readonly flareRulesetId: number;
  readonly reason: string;
  readonly dateCreated: number;
  readonly adminName: string;
}

/**
 * Create a Freelancer Automation Rule Engine (FLARE) admin log object
 */
export function generateFlareAdminLogObject({
  id = generateId(),
  flareRulesetId,
  reason,
  dateCreated,
  adminName,
}: GenerateFlareAdminLog): FlareAdminLog {
  return {
    id,
    flareRulesetId,
    reason,
    dateCreated,
    adminName,
  };
}
